import { HistoricalDataItem, useGetByIdAndTimeQuery } from "../../../services/historicalData";
import { Block } from "baseui/block";
import { useStyletron } from "baseui";
import { LoadingView } from "../../../components";
import { useMemo } from "react";
import { BooleanTimeline } from "../../../components/Charts/BooleanTimeline";
import { TTimelineEvent } from "../../../components/Charts/BooleanTimeline/BooleanTimeline";
import { BooleanTimeseriesStatistics } from "../../../components/Charts/BooleanTimeseriesStatistics";
import { VerticalStackPanel } from "../../../components/Layout/StackPanel";

const ObjectBooleanTimeline = (props: { objectId: string, resourceGroupId: string, propertyName: string, start: Date, end: Date, onColor: string, offColor: string, currentValue: boolean, showStatistics?: boolean, label?: any }) => {

    const { data, isLoading, isSuccess, error } = useGetByIdAndTimeQuery(
        {
            id: props.objectId,
            start: props.start.toUTCString(),
            end: props.end.toUTCString(),
            propertyName: props.propertyName,
            resourceGroupId: props.resourceGroupId
        })

    const events = useMemo(() => mapItems(data, props.currentValue, props.start, props.end), [data])

    return (
        <VerticalStackPanel $alignItems={'stretch'}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <BooleanTimeline  data={events} start={props.start} end={props.end} onColor={props.onColor} offColor={props.offColor}></BooleanTimeline>
            </LoadingView>
            {props.showStatistics &&
                <BooleanTimeseriesStatistics label={props.label} color={props.onColor} start={props.start} end={props.end} data={events}></BooleanTimeseriesStatistics>
            }
        </VerticalStackPanel>
    );

}

export default ObjectBooleanTimeline;


const mapItems = (data: HistoricalDataItem[] | undefined, currentValue: boolean, startDate: Date, endDate: Date) => {
    if (!data || data.length === 0) return [{ startDate: startDate, endDate: endDate, value: currentValue }];

    let result: TTimelineEvent[] = [];
    for (let i = 0; i < data.length; i++) {
        if (i === 0)
            result.push({ startDate: startDate, endDate: new Date(data[i].timeStamp), value: !data[i].value });

        let start = data[i].timeStamp;
        let end = i + 1 < data.length ? data[i + 1].timeStamp : endDate;
        result.push({ startDate: new Date(start), endDate: new Date(end), value: data[i].value });
    }

    return result;
}



